import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { photos } from "../../data/photography";
import { EditorialImage } from "../EditorialImage";
import { ledgerEase } from "../../utils/motion";
export function HomeHero() {
  return <section aria-labelledby="hero-title" className="shell pb-20 pt-12 md:pb-28 md:pt-16" data-id="element-158" data-mp="294j2wabr5oqm">
      <div className="grid grid-cols-12 gap-x-6 gap-y-12" data-id="element-159" data-mp="296dmnlbafat4">
        <div className="col-span-12 flex flex-col justify-between lg:col-span-7 lg:py-8 lg:pr-8" data-id="element-160" data-mp="2wvg2qoq9wvli">
          <div data-id="element-161" data-mp="31rwtzrsrrq2t">
            <div className="flex items-center gap-4" data-id="element-162" data-mp="31sevb2uaguhl">
              <span aria-hidden className="block h-px w-10 bg-oxblood" data-id="element-163" data-mp="2n53lp6ho3kk4" />
              <p className="eyebrow text-[12px] text-oxblood" data-id="element-164" data-mp="2s3etzcsbdn08">Payroll Operations + HR Technology</p>
            </div>
            <motion.h1 id="hero-title" initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease: ledgerEase
          }} className="mt-10 font-display text-[clamp(2.9rem,5.6vw,5.75rem)] leading-[1] tracking-[-0.02em] text-navy" data-id="element-165" data-mp="3fshc0lqv1hv9">
              Building exceptional payroll <em className="text-oxblood" data-id="element-166" data-mp="jub8yry9p9pb">and</em> HR technology operations.
            </motion.h1>
          </div>
          <div className="mt-12" data-id="element-167" data-mp="sx2nx1qcqnlp">
            <p className="max-w-lg text-lg leading-relaxed text-charcoal/85 md:text-xl" data-id="element-168" data-mp="svrgmrxp6xpu">
              We help companies run payroll, implement and optimize HR technology, and step in when either one stops
              working the way it should.
            </p>
            <div className="mt-10 flex flex-wrap gap-3" data-id="element-169" data-mp="1gm52u1tlq2ci">
              <Link to="/contact" className="btn-primary" data-id="element-170" data-mp="1gllvtg5hoyd9">
                Talk to Us
              </Link>
              <Link to="/services" className="btn-ghost" data-id="element-171" data-mp="1cll8f60excu2">
                Explore Services
              </Link>
            </div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.3,
        ease: ledgerEase
      }} className="col-span-12 lg:col-span-5" data-id="element-172" data-mp="3ecy5xa01wig3">
          <EditorialImage image={photos.homeHero} caption="Before the cycle opens. Everything already in its place." priority data-id="element-173" data-mp="1mbohd3aisnly" />
        </motion.div>
      </div>
    </section>;
}